<template>
    <div class="inteChangeDet">
        <div class="breadcrumb">奖品详情
            <el-button class="right_f" type="primary" @click="cancel">取消</el-button>
        </div>

        <div class="detail">
            <el-form ref="inteForm" :model="inteForm" label-width="130px">
                <el-form-item label="替换序号:" prop="position" required>
                    <el-select v-model="inteForm.position" style="width: 150px;" disabled>
                        <el-option :label="index + 1" :value="index + 1" v-for="(item,index) in 8"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="奖品名称：" required>
                    <el-input v-model="inteForm.prizeName" placeholder="奖品名称" class="inputTitle" disabled></el-input>
                </el-form-item>
                <el-form-item label="奖品图片：" required>
                    <img :src="inteForm.imgUrl" style="width:200px;display:inline-block;">
                    <br>
                    <span class="gray">（尺寸说明：360×300像素，jpg、jpeg、png）</span>
                </el-form-item>

                <el-form-item label="可中奖次数:" required>
                    <el-radio v-model="inteForm.isLimit" label="0" disabled>不限</el-radio>
                    <el-radio v-model="inteForm.isLimit" label="1" class="inline" disabled>限定</el-radio>
                    <br>
                    <el-input v-model="inteForm.drawHitCount" v-if='inteForm.isLimit=="1"' placeholder="请输入自定义数量" style="width: 250px;" class="probability"
                        disabled>
                        <template slot="append" style="line-height: 34px;">次</template>
                    </el-input>
                </el-form-item>

                <el-form-item label="自动兑奖:" required>
                    <el-radio v-model="inteForm.isAuto" label="1" disabled>是</el-radio>
                    <el-radio v-model="inteForm.isAuto" label="0" class="inline" disabled>否</el-radio>
                </el-form-item>

                <el-form-item label="是否无限:" required>
                    <el-radio v-model="inteForm.isInfinite" label="1" disabled>是</el-radio>
                    <el-radio v-model="inteForm.isInfinite" label="0" class="inline" disabled>否</el-radio>
                </el-form-item>

                <el-form-item label="兑奖URL:" prop="prizeUrl" required>
                    <el-radio v-model="inteForm.definePrizeUrl" label="false" disabled>不跳转</el-radio>
                    <br>
                    <el-radio v-model="inteForm.definePrizeUrl" label="true" class="inline" disabled>自定义URL</el-radio>
                    <br>
                    <el-input v-model="inteForm.prizeUrl" v-if='inteForm.definePrizeUrl=="true"' class="inputTitle" disabled></el-input>
                </el-form-item>

                <el-form-item label="广告曝光代码:" class="prizeContent">
                    <el-input type="textarea" :autosize="{minRows: 5}" disabled v-model="inteForm.adExposingCodes">
                    </el-input>
                </el-form-item>

                <el-form-item label="文案类型：" class="prizeContent" required>
                    <el-radio v-model="inteForm.isRedeem" label="1" disabled>兑奖码类型</el-radio>
                    <el-radio v-model="inteForm.isRedeem" label="0" class="inline" disabled>自定义文案</el-radio>
                </el-form-item>

                <el-form-item label="文案:" class="prizeContent">
                    <el-input type="textarea" :autosize="{minRows: 5}" disabled v-model="inteForm.defineText">
                    </el-input>
                </el-form-item>

                <el-form-item prop="startTime" class="time" label="兑换开始时间：">
                    <el-date-picker v-model="inteForm.startTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd" class="qizhiDate" disabled></el-date-picker>
                </el-form-item>

                <el-form-item prop="endTime" class="time" label="兑换结束时间：">
                    <el-date-picker v-model="inteForm.endTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd" class="qizhiDate" disabled></el-date-picker>
                </el-form-item>

                <select-school :schObj="inteForm.schObj" :canUse="canUse"></select-school>

                <el-form-item class="time" label="替换开始时间：" required>
                    <el-date-picker v-model="inteForm.replaceStartTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd" class="qizhiDate" disabled></el-date-picker>
                </el-form-item>

                <el-form-item class="time" label="替换结束时间：" required>
                    <el-date-picker v-model="inteForm.replaceEndTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd" class="qizhiDate" disabled></el-date-picker>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    import { mapState, mapActions } from "vuex";
    import selectSchool from "../../common/selectSch.vue"

    export default {
        data() {
            return {
                inteForm: {
                    schObj: {}
                },
                canUse: false,
                isReplace: this.$util.getUrlParam("isReplace"),
                operatorId: this.$store.state.user.userId
            };
        },
        mounted() {
            //根据position获取奖品详情
            let id = this.$util.getUrlParam("id") * 1;
            this.getDetail(id);
        },
        components: { selectSchool },
        methods: {
            cancel() {
                if (this.isReplace == "1") {
                    location.href = "/#/yunying/integration/integration?isFirst=1";
                } else {
                    location.href =
                        "/#/yunying/integration/downline?online=" + this.isReplace;
                }
            },
            //获取奖品详情
            getDetail(id) {
                let url = this.$util.domain + "/adminapi/v2/rounddisk/replace/detail";

                this.$http({
                    url,
                    method: "POST",
                    headers: {
                        operatorId: this.operatorId + ""
                    },
                    body: JSON.stringify({
                        id: id
                    })
                }).then(response => {
                    if (response.data.error == 10000) {
                        let item = response.data.data;
                        this.inteForm = {
                            id: item.id,
                            schObj: {
                                applicableCampus: item.applicableCampus + "",
                                shieldedSchools: [], //屏蔽的学校
                                openedSchools: [] //应用的学校
                            },
                            position: item.position,
                            prizeName: item.prizeName,
                            probability: item.probability / 100,
                            imgUrl: item.imgUrl,
                            drawHitCount: item.drawHitCount,
                            isLimit: item.drawHitCount == -1 ? "0" : "1",
                            prizeUrl: item.prizeUrl,
                            fileUrl: item.fileUrl,
                            adExposingCodes: item.adExposingCodes,
                            isRedeem: item.isRedeem + "",
                            defineText: item.isRedeem == 1 ? item.redeemText : item.defineText,
                            startTime: item.startTime,
                            endTime: item.endTime,
                            replaceEndTime: item.replaceEndTime ? item.replaceEndTime : "",
                            replaceStartTime: item.replaceStartTime
                                ? item.replaceStartTime
                                : "",
                            isAuto: item.isAuto + "",
                            isInfinite: item.isInfinite + "",
                            definePrizeUrl: item.definePrizeUrl + ""
                        };

                        item.applicableCampus == 0
                            ? (this.inteForm.schObj.shieldedSchools = item.campusList || [])
                            : (this.inteForm.schObj.openedSchools = item.campusList || []);
                    }
                });
            }
        }
    };
</script>

<style>
    .inputTitle {
        width: 40%;
    }

    .qizhiDate {
        display: inline-block;
        width: 100%;
    }

    .inteChangeDet .time {
        width: 40%;
    }

    .inteChangeDet .irregular {
        display: inline-block;
    }

    .gray {
        color: #999;
    }

    .probability .el-input__inner {
        height: 38px;
    }

    .inteChangeDet .el-input-group__append {
        line-height: 34px;
        height: 34px;
    }

    .inteChangeDet .el-radio__inner.is-disabled.is-checked {
        background-color: black;
        border-color: black;
    }
</style>


// WEBPACK FOOTER //
// inteChangeDet.vue?d4a5e4a8